import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/index.ts
import { useMemo, useState } from "react";
import { useCallbackRef } from "@chakra-ui/react-use-callback-ref";
function useControllableProp(prop, state) {
  var controlled = typeof prop !== "undefined";
  var value = controlled ? prop : state;
  return useMemo(function () {
    return [controlled, value];
  }, [controlled, value]);
}
function useControllableState(props) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    onChange = props.onChange,
    _props$shouldUpdate = props.shouldUpdate,
    shouldUpdate = _props$shouldUpdate === void 0 ? function (prev, next) {
      return prev !== next;
    } : _props$shouldUpdate;
  var onChangeProp = useCallbackRef(onChange);
  var shouldUpdateProp = useCallbackRef(shouldUpdate);
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    uncontrolledState = _useState2[0],
    setUncontrolledState = _useState2[1];
  var controlled = valueProp !== void 0;
  var value = controlled ? valueProp : uncontrolledState;
  var setValue = useCallbackRef(function (next) {
    var setter = next;
    var nextValue = typeof next === "function" ? setter(value) : next;
    if (!shouldUpdateProp(value, nextValue)) {
      return;
    }
    if (!controlled) {
      setUncontrolledState(nextValue);
    }
    onChangeProp(nextValue);
  }, [controlled, onChangeProp, value, shouldUpdateProp]);
  return [value, setValue];
}
export { useControllableProp, useControllableState };